









import { Vue, Component, Prop } from 'vue-property-decorator';

import CustomerImportFailure from '@/componentsV2/templates/CustomerImportFailure/CustomerImportFailure.vue';
import { EEmptyStateTabs } from './CustomerImportEmptyState.vue';

@Component({
  components: {
    CustomerImportFailure
  }
})
export default class CustomerImportError extends Vue {
  handleTryAgain() {
    this.$analytics({
      eventCategory: `Import Customers Modals | Customer Import Error`,
      eventAction: 'click',
      eventLabel: `Clicked on the "Try again" button`
    });

    this.$emit('empty-state-event', {
      type: 'goTo',
      data: { step: EEmptyStateTabs.PROGRESS }
    });
  }
}
